/* ★ POPUP "MODEL VIDEO TIADA" — Run Flow DIHENTIKAN oleh robot (keputusan user 2026-09-24).
 *
 * Robot Flow menyemak model Video pilihan Control Panel sebelum mencipta collection. Model tiada dalam
 * akaun Google Flow pelanggan (cth "Veo 3.1 - Lite [Lower Priority]" = pakej Ultra sahaja) → larian
 * berhenti, tiada kredit digunakan, dan popup ini dipapar (popup serupa juga di halaman Flow).
 *
 * TEKS SAHAJA. Rupa dikongsi: PopupRunDitahan. Data: hooks/usePantauModelFlow.js.
 * info: { diminta, ada[], kad: [{ id, nama }] }
 */
import React from 'react';
import PopupRunDitahan from './PopupRunDitahan';

export default function PopupModelFlowTiada({ info, onTutup, T }) {
    if (!info || !info.diminta) return null;

    const ultra = /lower priority/i.test(info.diminta);
    const ada = Array.isArray(info.ada) ? info.ada.join(', ') : '';

    return (
        <PopupRunDitahan
            ikon="videocam_off"
            idTajuk="pmft-tajuk"
            tajuk={T('ws.flowModel.tajuk', 'Run dihentikan — model video tiada')}
            sebab={(ultra
                ? T('ws.flowModel.sebabUltra', `Model video "${info.diminta}" tiada dalam akaun Google Flow anda. Model ini hanya tersedia untuk pakej Google AI Ultra.`, { model: info.diminta })
                : T('ws.flowModel.sebab', `Model video "${info.diminta}" tiada dalam akaun Google Flow anda.`, { model: info.diminta }))
                + ' ' + T('ws.flowModel.tiadaKredit', 'SESAAT berhenti sebelum mencipta collection, jadi tiada kredit Flow digunakan.')}
            senarai={(info.kad || []).map((k) => ({ id: k.id, nama: k.nama, keterangan: T('ws.flowModel.baris', 'Dihentikan sebelum collection dicipta') }))}
            caraTajuk={T('ws.flowModel.caraTajuk', 'Cara betulkan')}
            gayaLangkah
            cara={[
                T('ws.flowModel.langkah1', 'Buka Control Panel → Flow'),
                ada
                    ? { teks: T('ws.flowModel.langkah2Ada', 'Pilih model Video yang tersedia dalam akaun anda'), tag: info.ada }
                    : T('ws.flowModel.langkah2', 'Pilih model Video lain'),
                T('ws.flowModel.langkah3', 'Tekan Run semula'),
            ]}
            nota={T('ws.flowModel.nota', 'Card lain dalam Run ini juga tidak dijalankan.')}
            butang={T('ws.flowModel.faham', 'Faham')}
            onTutup={onTutup}
            T={T}
        />
    );
}
